import { useFirestoreSubscription } from '@/services/firebase/useFirestoreSubscription';
import { useWalletStore } from '@/stores/walletStore';
import { mapWalletEntityDto, type WalletEntityDto } from '@/types';

/**
 * Wallet realtime hook(R45 / Beta v0.0.1 Phase 2)
 * -----------------------------------------------------------------------------
 * 訂閱 `users/{cuid}/wallets/{gid}` doc onSnapshot;任何 reserve / settle / refund /
 * topup / monthly_grant 寫入即時推到 walletStore(對齊 docs/40 §6.3)。
 *
 * Caller 傳:
 * - `cuid`(useAuthStore.creativeUid)
 * - `gid`(useGroupContextStore.currentGroupId 或 project.group_id;spec §6.5 警告
 *   — job 扣的是 project.group_id 不是 currentGroupId,UI 顯示前要小心)
 *
 * 兩者 `null` 時 hook no-op(`useFirestoreSubscription` empty path skip)。
 */
export function useWalletRealtime(cuid: string | null, gid: string | null): void {
  const path = cuid && gid ? `users/${cuid}/wallets/${gid}` : '';

  useFirestoreSubscription<WalletEntityDto>({
    path,
    type: 'doc',
    onSnapshot: (data) => {
      if (!data) return; // doc 不存在(尚未首登 / 已被刪)
      if (!gid) return;
      const wallet = mapWalletEntityDto(data);
      // groupId guard 在 store setter 內:wallet.groupId !== gid 會 warn drop
      useWalletStore.getState().setWallet(gid, wallet);
    },
    onError: (err) => {
      console.warn('[wallet-realtime] onSnapshot error', err);
    },
  });
}
